import {filterListTypeValues} from 'common/api/dictionaries'
import {FC} from 'react'
import {DictionarySelector, DictionarySelectorProps} from './DictionarySelector'

export const FilterListTypeSelector: FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="filterListType"
                        loader={() => Promise.resolve(filterListTypeValues)}
    />
